import { MenuItem, Select, InputLabel, FormControl , Paper, TextField, Button, Typography, List, ListItem, ListItemText, ListItemIcon,Modal, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import SideBar from "../components/sidebar/Sidebar";
import UserBase from "../components/user/UserBase";
import {confirmTicketResolution, getUserTicketHistory,getFile , submitRegisteredRequest, submitRegisteredRequestWithFile, getTicketMessages, sendTicketMessage } from "../services/supportService";
import "../css/SupportRequest.css";
import { Container, Box, CircularProgress } from '@mui/material';
import { useEffect } from "react";
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
const SupportRequest = () => {
  const [formData, setFormData] = useState({
    subject: "",
    subjectType: "Preset",
    message: "",
    subSubject: "",
    subSubjectType: "Preset",
  });

  const [files, setFiles] = useState([]);
  const [ticketHistory, setTicketHistory] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageHistory, setMessageHistory] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSupportForm, setShowSupportForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [loadingTicketId, setLoadingTicketId] = useState(null); // for spinner + disable
  const [showAcknowledgementDialog, setShowAcknowledgementDialog] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);

  const handleAcknowledgeClick = () => {
    setShowAcknowledgementDialog(true);
  };
  const handleDialogClose = () => {
    setShowAcknowledgementDialog(false);
  };
   useEffect(() => {
    fetchTicketHistory();
  }, []);
  const handleCloseMessages = () => {
    setShowMessagesModal(false);
  };
const handleResolutionResponse = async (response) => {
  try {
    setConfirmationLoading(true);
    const normalizedResponse = response === "yes";
    const newStatus = normalizedResponse ? "CLOSED" : "REOPEN";

    await confirmTicketResolution(selectedTicket.id, normalizedResponse);

    setSelectedTicket((prev) => ({
      ...prev,
      status: newStatus,
      userConfirmedResolved: normalizedResponse,
    }));

    setTickets((prev) =>
      prev.map((ticket) =>
        ticket.id === selectedTicket.id
          ? {
              ...ticket,
              status: newStatus,
              userConfirmedResolved: normalizedResponse,
            }
          : ticket
      )
    );

    if (normalizedResponse) {
      toast.success("Ticket marked as closed.");
    } else {
      toast.success("Ticket status changed to reopen.");
    }

    fetchTicketHistory(); 
    handleDialogClose();
  } catch (error) {
    toast.error("Failed to update ticket resolution.");
  } finally {
    setConfirmationLoading(false);
  }
};

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  setFiles(selectedFiles);
};

  const normalizeStatus = (status) => {
    if (!status) return 'open';
    const cleaned = status.toLowerCase().replace(/\s|_/g, '');
    if (cleaned.includes('open') && !cleaned.includes('reopen')) return 'open';
    if (cleaned.includes('inprogress')) return 'in-progress';
    if (cleaned.includes('reopen')) return 'reopen';
    if (cleaned.includes('solved')) return 'solved';
    if (cleaned.includes('closed')) return 'closed';
    return 'open';
  };
  
const downloadFile = async (contactRequestId, fileName) => {
  try {
    const response = await getFile(contactRequestId, fileName);
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName || 'attachment';
    link.click();
    link.remove();
  } catch (err) {
    console.error("Failed to download file", err);
  }
};
const handleSubmit = async (e) => {
  e.preventDefault();

  const finalSubject =
    formData.subject === "International Assets"
      ? formData.subSubjectType === "Others"
        ? formData.subSubject
        : `Issues in International Assets - ${formData.subSubject}`
      : formData.subject;

  try {
    setLoading(true);
    const formDataWithFile = new FormData();

    const requestObject = {
      subject: finalSubject,
      message: formData.message,
    };

    formDataWithFile.append("request", new Blob([JSON.stringify(requestObject)], { type: "application/json" }));

    if (files && files.length > 0) {
      files.forEach((file) => {
        formDataWithFile.append("files", file); 
      });
    }

    await submitRegisteredRequestWithFile(formDataWithFile);

    toast.success("Support request submitted successfully", {
      position: toast.POSITION.BOTTOM_CENTER,
    });

    setFormData({
      subject: "",
      subjectType: "Preset",
      message: "",
      subSubject: "",
      subSubjectType: "Preset",
    });
    setFiles([]); 
    setShowSupportForm(false); 
    setOpenHistory(true);
    await fetchTicketHistory();

  } catch (error) {
    toast.error("Failed to submit request", {
      position: toast.POSITION.BOTTOM_CENTER,
    });

    setFormData({
      subject: "",
      subjectType: "Preset",
      message: "",
      subSubject: "",
      subSubjectType: "Preset",
    });
    setFiles([]); 
    setShowSupportForm(false);
  } finally {
    setLoading(false);
  }
};


const fetchTicketHistory = async () => {
  try {
    const data = await getUserTicketHistory();

    if (!Array.isArray(data)) {
      throw new Error("Ticket history is not an array");
    }

    const sorted = data.sort(
      (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
    );

    setTicketHistory(sorted);
    setOpenHistory(true);
  } catch (error) {
    console.error("Fetch ticket history error:", error);
    toast.error("Failed to fetch ticket history");
  }
};

  const handleOpenMessages = async (ticketId) => {
    try {
      const messages = await getTicketMessages(ticketId);
      setMessageHistory(messages);
      setSelectedTicketId(ticketId);
      setShowMessageModal(true);
    } catch (error) {
      toast.error("Failed to load messages.");
    }
  };
  const handleImageClick = () => {
    setOpenTicketModal(true);
  };
  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;
  
    const optimisticMessage  = {
      sender: "USER",
      content: newMessage,
      timestamp: new Date().toISOString(),
      temp: true, 
    };
  
    setMessageHistory((prev) => [...prev, optimisticMessage]);

  const messageToSend = newMessage;
  setNewMessage("");
  
    try {
      await sendTicketMessage(selectedTicketId, {
        sender: "USER",
        content: messageToSend,
      });
  
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    }
  };
const [selectedTicket, setSelectedTicket] = useState(null);
const [openTicketModal, setOpenTicketModal] = useState(false);

const handleViewTicketDetails = (ticket) => {
  setSelectedTicket(ticket);
  setOpenTicketModal(true);
};

  const [filter, setFilter] = useState('all');

  const filteredTickets = ticketHistory.filter((ticket) => {
   const matchesSearch = 
  ticket.id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
  ticket.subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  ticket.message?.toLowerCase().includes(searchTerm.toLowerCase());

  
    const ticketDate = new Date(ticket.createdDate);
    const now = new Date();
    let matchesFilter = true;
  
    if (filter === 'week') {
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(now.getDate() - 7);
      matchesFilter = ticketDate >= oneWeekAgo;
    } else if (filter === 'month') {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(now.getMonth() - 1);
      matchesFilter = ticketDate >= oneMonthAgo;
    } else if (filter === 'year') {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      matchesFilter = ticketDate >= oneYearAgo;
    }
  
    return matchesSearch && matchesFilter;
  });
  
  return (
    <div className="your-component fade-in-element">
    <UserBase>
      <div style={{ marginTop: "4rem" }} className="otherElement">
        <SideBar>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h5" className="bold-heading"  sx={{ ml: 2}}>
        Your Support Requests
      </Typography>
     
    </Box>
 {!showSupportForm && (
        <Button variant="text" onClick={() => setShowSupportForm(true)} sx={{ fontWeight: 'bold', color: '#007BFF' }}>
          &nbsp;&nbsp;&nbsp;&nbsp;+ Make Support Request
        </Button>
      )}

<div className="propCard">
  <div className="propCard-card">
    {ticketHistory.length === 0 && (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#888' }}>
        <Typography variant="body1">No support tickets found.</Typography>
      </div>
    )}

    {ticketHistory.length > 0 && ticketHistory.map((ticket) => (
      <div className="propCard-card-body" key={ticket.id}>
        <div className="propCard_card_status">
          <p className={`propCard_card_status_text ${normalizeStatus(ticket.status)}`}>
            {(() => {
              const labelMap = {
                'in-progress': 'In Progress',
                'solved': 'Solved',
                'open': 'Open',
                'reopen': 'Reopen',
                'closed': 'Closed',
              };
              const normalized = normalizeStatus(ticket.status);
              return labelMap[normalized] || normalized;
            })()}
          </p>
        </div>

        <div className="propCard-card-title">
          <h5 className="card_subject">{ticket.subject}</h5>
        </div>

        <p className="propCard-card-text">
          Submitted on: {new Date(ticket.createdDate).toLocaleString()}
        </p>

        <div className="propCard-btn">
          <button onClick={() => handleViewTicketDetails(ticket)}>
            View Details
          </button>
        </div>
      </div>
    ))}

  </div>
</div>
<Modal open={openTicketModal} onClose={() => setOpenTicketModal(false)}>
  <Box className="ticket_modal_box">
  {selectedTicket && (
  <>
  <Typography variant="h6">Ticket Details</Typography>
    <section className="section21">
      <div className="col-wrapper">
        <div className="col11">
          <p>
            Ticket ID: <code1>{selectedTicket.id}</code1>
          </p>
          <p>
            Subject: <code1>{selectedTicket.subject}</code1>
          </p>
          <p>
            Message: <code1>{selectedTicket.message}</code1>
          </p>
          <Tooltip title="Click to view submission date">
            <p>
              Submitted on:&nbsp;
              <code1>{new Date(selectedTicket.createdDate).toLocaleString()}</code1>
            </p>
          </Tooltip>
            {selectedTicket.fileNames && selectedTicket.fileNames.length > 0 && (
              <div>
                <p>Uploaded Files:</p>
                <ul>
                  {selectedTicket.fileNames.map((fileName, index) => (
                    <li key={index}>
                      <span
                        onClick={() => downloadFile(selectedTicket.id, fileName)}
                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                      >
                        {fileName}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}


        </div>
          <div className="col2">
            <div className="status-tracker-wrapper">
              <div className="col1"><p>Status:</p></div>
              
              <div className="status-tracker">
                {(() => {
                  const normalizedStatus = normalizeStatus(selectedTicket.status);
                  const includeReopen = selectedTicket.userConfirmedResolved === false;
                  const steps = ['open', 'in-progress', ...(includeReopen ? ['reopen'] : []), 'solved', 'closed'];
                  const currentIndex = steps.indexOf(normalizedStatus);

                  return steps.map((step, index, arr) => {
                    const isFilled = index < currentIndex;
                    const isCurrent = index === currentIndex;
                    const isLast = index === arr.length - 1;

                    return (
                      <div className="status-step" key={step}>
                        <div className="circle-line-wrapper">
                            <div className={`circle ${(isFilled || isCurrent) ? 'complete' : ''} ${isCurrent ? 'active' : ''}`}>
                            {index + 1}
                          </div>
                          {!isLast && (
                            <div className={`line ${isFilled ? 'filled' : ''}`}></div>
                          )}
                        </div>
                        <div className={`label ${isFilled ? 'complete' : ''} ${isCurrent ? 'active' : ''}`}>
                          <span style={{ display: 'block', fontWeight: isCurrent ? 'bold' : 'normal', marginBottom: '0.3rem' }}>
                            {{
                              'in-progress': 'Inprogress\u00A0\u00A0',
                              'solved': 'Solved',
                              'open': 'Open',
                              'reopen': 'Reopen',
                              'closed': 'Closed',
                            }[step] || step}
                          </span>
                        </div>
                      </div>
                    );
                  });
                })()}
              </div> 

              {normalizeStatus(selectedTicket.status) === "solved" && (
                <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
                  <button
                    onClick={handleAcknowledgeClick}
                    style={{
                      backgroundColor: 'white',
                      color: '#1976d2',
                      border: '2px solid #1976d2',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      marginLeft: '200px',
                      transition: 'background-color 0.3s ease',
                    }}
                  >
                    Acknowledge
                  </button>
                </div>
              )}
            </div>
          </div>


        <Dialog open={showAcknowledgementDialog} onClose={handleDialogClose}>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Ticket Resolution</Typography>
            <IconButton onClick={handleDialogClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>          
          <DialogContent>
          <Box display="flex" flexDirection="column" gap={3}>
            <Box>
              <Typography variant="body1" gutterBottom>
                We are committed to ensuring your issue is fully addressed. Could you please confirm whether the issue you're experiencing has been solved?
              </Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                If you click "Yes", it will be assumed that your problem has been solved, and the support ticket will be closed. If you're still facing issues, please click "No" to reopen the request and get further assistance.
              </Typography>
            </Box>

            <Box display="flex" flexDirection="column" gap={1}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleResolutionResponse("yes")}
                disabled={confirmationLoading}
                fullWidth
              >
                Yes, the problem is solved
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleResolutionResponse("no")}
                disabled={confirmationLoading}
                fullWidth
              >
                No, the problem is not solved
              </Button>
            </Box>
          </Box>
          </DialogContent>
        </Dialog>

          {selectedTicket.attachment && (
            <p>
              Attachment:<br />
              <img src={selectedTicket.attachment} alt="attachment" style={{ maxWidth: '100%', borderRadius: 8 }} />
            </p>
          )}
          
        </div>
    </section>

    <div className="ticket_modal_actions">
      <Button onClick={() => handleOpenMessages(selectedTicket.id)}>Message</Button>
      <Button onClick={() => setOpenTicketModal(false)}>Close</Button>
    </div>
    </>
  )}
  </Box>
</Modal>

{showSupportForm && (
  <Dialog
    open={showSupportForm}
    onClose={() => setShowSupportForm(false)}
    maxWidth="md"
    fullWidth
  >
    <DialogTitle>Submit a Support Request</DialogTitle>
    <DialogContent dividers>
      <Paper className="support_detail_card" sx={{ padding: 2 }}>
        <section className="section21">
          <div className="col-wrapper">
            <div className="col1">
              <form onSubmit={handleSubmit} className="form_column">
                <FormControl fullWidth required sx={{ mb: 2 }}>
                  <InputLabel id="subject-label">Subject</InputLabel>
                  <Select
                    labelId="subject-label"
                    id="subject"
                    name="subject"
                    value={formData.subjectType === "Others" ? "Others" : formData.subject}
                    label="Subject"
                    onChange={(e) => {
                      const selected = e.target.value;
                      if (selected === "Others") {
                        setFormData((prev) => ({ ...prev, subject: "", subjectType: "Others" }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          subject: selected,
                          subjectType: "Preset",
                          subSubject: "",
                          subSubjectType: "Preset"
                        }));
                      }
                    }}
                  >
                    <MenuItem value="Issues in Real Estate">Issues in Real Estate</MenuItem>
                    <MenuItem value="Issues in Bank">Issues in Bank</MenuItem>
                    <MenuItem value="Issues in Investment">Issues in Investment</MenuItem>
                    <MenuItem value="Issues in Insurance">Issues in Insurance</MenuItem>
                    <MenuItem value="Issues in Vehicle">Issues in Vehicle</MenuItem>
                    <MenuItem value="Issues in Business Passive Income">Issues in Business Passive Income</MenuItem>
                    <MenuItem value="Issues in Bitcoin">Issues in Bitcoin</MenuItem>
                    <MenuItem value="Issues in Jewelry">Issues in Jewelry</MenuItem>
                    <MenuItem value="Issues in Miscellaneous Assets">Issues in Miscellaneous Assets</MenuItem>
                    <MenuItem value="Issues in International Assets">Issues in International Assets</MenuItem>
                    <MenuItem value="Issues in Total Networth Graph">Issues in Total Networth Graph</MenuItem>
                    <MenuItem value="Issues in Dairy">Issues in Dairy</MenuItem>
                    <MenuItem value="Issues in Credit Card">Issues in Credit Card</MenuItem>
                    <MenuItem value="Issues in Mortgage Loan">Issues in Mortgage Loan</MenuItem>
                    <MenuItem value="Issues in Personal Loan">Issues in Personal Loan</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>

                {formData.subjectType === "Others" && (
                  <TextField
                    label="Custom Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                  />
                )}
                {formData.subject === "Issues in International Assets" && (
                  <>
                    <FormControl fullWidth required sx={{ mb: 2 }}>
                      <InputLabel id="subsubject-label">International Asset Type</InputLabel>
                      <Select
                        labelId="subsubject-label"
                        id="subSubject"
                        name="subSubject"
                        value={formData.subSubjectType === "Others" ? "Others" : formData.subSubject}
                        label="International Asset Type"
                        onChange={(e) => {
                          const selected = e.target.value;
                          if (selected === "Others") {
                            setFormData((prev) => ({ ...prev, subSubject: "", subSubjectType: "Others" }));
                          } else {
                            setFormData((prev) => ({ ...prev, subSubject: selected, subSubjectType: "Preset" }));
                          }
                        }}
                      >
                        <MenuItem value="Issues in International Real Estate">Issues in International Real Estate</MenuItem>
                        <MenuItem value="Issues in International Bank">Issues in International Bank</MenuItem>
                        <MenuItem value="Issues in International Investment">Issues in International Investment</MenuItem>
                        <MenuItem value="Issues in International Insurance">Issues in International Insurance</MenuItem>
                        <MenuItem value="Issues in International Vehicle">Issues in International Vehicle</MenuItem>
                        <MenuItem value="Issues in International Business Passive Income">Issues in International Business Passive Income</MenuItem>
                        <MenuItem value="Issues in International Bitcoin">Issues in International Bitcoin</MenuItem>
                        <MenuItem value="Issues in International Jewelry">Issues in International Jewelry</MenuItem>
                        <MenuItem value="Issues in International Miscellaneous Assets">Issues in International Miscellaneous Assets</MenuItem>
                        <MenuItem value="Others">Others</MenuItem>
                      </Select>
                    </FormControl>

                    {formData.subject === "Issues in International Assets" &&
                      formData.subSubjectType === "Others" && (
                        <TextField
                          label="Custom International Asset Subject"
                          name="subSubject"
                          value={formData.subSubject}
                          onChange={handleChange}
                          fullWidth
                          required
                          sx={{ mb: 2 }}
                        />
                      )}
                  </>
                )}

                <TextField
                  label="Message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                />
                <Box
                  component="label"
                  htmlFor="file-upload"
                  sx={{
                    display: 'inline-block',
                    border: '1px solid black',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    mb: 2,
                  }}
                >
                  Upload File
                  <input
                    id="file-upload"
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    accept="image/*,application/pdf"
                    style={{ display: 'none' }}
                  />
                </Box>

                {files.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="subtitle1">Selected File:</Typography>
                    <List dense>
                      {files.map((file, index) => (
                        <ListItem key={index}>
                          <ListItemIcon>
                            {file.type.startsWith('image/') ? (
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
                              />
                            ) : file.type === 'application/pdf' ? (
                              <PictureAsPdfIcon color="error" />
                            ) : (
                              <InsertDriveFileIcon />
                            )}
                          </ListItemIcon>
                          <ListItemText primary={file.name} />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                )}

                {formData.file && (
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    Uploaded: {formData.file.name}
                  </Typography>
                )}

                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button type="submit" variant="contained" disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Submit'}
                  </Button>
                  <Button variant="outlined" onClick={() => setShowSupportForm(false)}>
                    Cancel
                  </Button>
                </Box>
              </form>
            </div>
          </div>
        </section>
      </Paper>
    </DialogContent>
  </Dialog>
)}



    </SideBar>
    </div>
    </UserBase>
<Dialog open={showMessageModal} onClose={() => setShowMessageModal(false)} fullWidth maxWidth="sm">
  <DialogTitle>
    Message History
    <IconButton
      aria-label="close"
      onClick={() => setShowMessageModal(false)}
      sx={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    <Box sx={{ maxHeight: '300px', overflowY: 'auto', mb: 2 }}>
      {messageHistory.length === 0 ? (
        <Typography>No messages yet.</Typography>
      ) : (
        messageHistory.map((msg, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: msg.sender === 'USER' ? 'flex-end' : 'flex-start',
              mb: 1
            }}
          >
            <Box
              sx={{
                backgroundColor: msg.sender === 'USER' ? '#DCF8C6' : '#EEE',
                p: 1,
                borderRadius: 2,
                maxWidth: '75%',
              }}
            >
              <Typography variant="body2">{msg.content}</Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(msg.timestamp).toLocaleString()}
              </Typography>
            </Box>
          </Box>
        ))
      )}
    </Box>
    <Box sx={{ display: 'flex', mt: 2 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Type your message..."
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
      />
      <Button variant="contained" color="primary" onClick={handleSendMessage} sx={{ ml: 1 }}>
        Send
      </Button>
    </Box>
  </DialogContent>
</Dialog>

  </div>
);
};

export default SupportRequest;